/**
 * The domain enums this app owns.
 *
 * `Country`, `Currency`, `Environment`, `Language` and `SearchModes` are deliberately NOT copied
 * here: @lmn/lmn-commonlogic types its public API with @lmn/lmn-domainlogic's versions and also
 * validates them at runtime (`!!Country[code]`, `searchMode === SearchModes.DP`), so a second copy
 * would have to be kept byte-compatible forever - and adding a member locally would break every
 * call into lmn-commonlogic until the package caught up. They are re-exported from the package
 * instead, so there is exactly one definition.
 *
 * The import points at the enum module rather than the package root on purpose: the package is CJS
 * with no `exports` map and no `sideEffects` flag, so importing its barrel drags getUSP, getRatings,
 * formatPrice and the currency formatter into the client bundles. `dist/common` has no requires.
 *
 * `Brand` and `LeisureType` never cross that boundary, so they live here. Note that `Brand`'s member
 * names differ from their values (WEGDE = 'weg', MILLEMIGLIA = 'mymiglia', HOTELSPECIAL = 'hspecial').
 */

// eslint-disable-next-line no-restricted-imports -- the single intentional import; see above
export { Country, Currency, Environment, Language, SearchModes } from '@lmn/lmn-domainlogic/dist/common';

export enum Brand {
  BOOKING = 'booking',
  BRAVOFLY = 'bravofly',
  FREEHOTEL = 'freehotel',
  HOLIDAYGURU = 'holidayguru',
  HOLIDAYPIRATES = 'holidaypirates',
  HOTELSPECIAL = 'hspecial',
  LASTMINUTE = 'lastminute',
  LUFTHANSA = 'lufthansa',
  MILLEMIGLIA = 'mymiglia',
  RUMBO = 'rumbo',
  THB = 'THB',
  VIAJAR = 'viajar',
  VIBRA = 'vibra',
  VOLAGRATIS = 'volagratis',
  WEGDE = 'weg',
}

export enum LeisureType {
  BEACH = 'L1',
  EXOTIC = 'L2',
  SKI = 'L3',
  CITY_BREAKS = 'L4',
  SPA = 'L5',
}
